import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "roadsideAssistance"
const RoadsideAssistanceIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M4.688 3.297C4.468 2.593 5.383 1.981 5.95 2.57L13.688 10.604V8.437H16.5C17.632 8.437 18.668 9.077 19.174 10.09L20.322 12.387 21.82 13.586C22.13 13.833 22.312 14.21 22.312 14.61V19.125C22.313 19.849 21.726 20.437 21 20.437H19.523C19.069 21.222 18.22 21.75 17.25 21.75S15.431 21.222 14.977 20.437H8.647C8.195 21.222 7.348 21.75 6.376 21.75 5.211 21.75 4.225 20.993 3.881 19.944L2.801 19.78C2.16 19.68 1.687 19.129 1.687 18.48V15.75C1.688 15.025 2.276 14.437 3 14.437H11.03L5.813 5.305V8.89Q6.088 8.969 6.334 9.12C6.65 9.316 6.908 9.594 7.08 9.924 7.25 10.254 7.33 10.624 7.309 10.996 7.287 11.367 7.165 11.726 6.957 12.034 6.747 12.342 6.459 12.587 6.122 12.744 5.785 12.903 5.412 12.965 5.042 12.928S4.316 12.753 4.018 12.53C3.72 12.309 3.488 12.009 3.345 11.666L4.385 11.235C4.448 11.391 4.554 11.527 4.69 11.628 4.826 11.728 4.987 11.79 5.155 11.808S5.493 11.796 5.646 11.725 5.931 11.542 6.026 11.402 6.176 11.099 6.186 10.93 6.16 10.593 6.082 10.443 5.887 10.167 5.742 10.078C5.6 9.988 5.435 9.94 5.266 9.938V9.936L5.25 9.937C4.94 9.937 4.688 9.686 4.688 9.375zM6.375 18C5.754 18 5.25 18.503 5.25 19.125 5.25 19.746 5.754 20.25 6.375 20.25S7.5 19.746 7.5 19.125C7.5 18.503 6.996 18 6.375 18M17.25 18C16.629 18 16.125 18.503 16.125 19.125 16.125 19.746 16.629 20.25 17.25 20.25S18.375 19.746 18.375 19.125C18.375 18.503 17.871 18 17.25 18M3 15.562C2.897 15.562 2.813 15.646 2.813 15.75V16.687H3C3.31 16.687 3.562 16.94 3.563 17.25S3.31 17.812 3 17.812H2.813V18.481C2.813 18.573 2.88 18.653 2.97 18.667L3.772 18.789C3.937 17.5 5.039 16.5 6.375 16.5 7.825 16.5 9 17.676 9 19.126Q9 19.219 8.993 19.312H13.688V15.562zM14.813 18.151C15.199 17.183 16.145 16.5 17.25 16.5 18.7 16.5 19.875 17.675 19.875 19.125Q19.875 19.219 19.868 19.312H21C21.104 19.312 21.188 19.228 21.188 19.125V18.187H21C20.69 18.187 20.438 17.935 20.438 17.625S20.69 17.062 21 17.062H21.188V14.61C21.188 14.553 21.162 14.499 21.118 14.464L19.677 13.312H18C16.86 13.312 15.938 12.39 15.938 11.25V9.562H14.812zM12.273 14.343C12.306 14.4 12.368 14.437 12.435 14.437H13.5C13.604 14.437 13.688 14.353 13.688 14.25V12.226L7.232 5.523zM17.063 11.25C17.063 11.767 17.483 12.187 18 12.187H18.965L18.168 10.593C17.938 10.135 17.536 9.8 17.063 9.65z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default RoadsideAssistanceIcon
